var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 28,
    viewBox: "0 0 80 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 28L0.162829 0.249998L79.8372 0.250005L40 28Z",
    fill: "#007FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowSection);
export default __webpack_public_path__ + "static/media/down-arrow-section.6a26ea2c82e9e4b965e3e0decedd2d87.svg";
export { ForwardRef as ReactComponent };